import styled from 'styled-components'

const Header = styled('span')`
  padding: 16px;
`

export default Header
